export interface ErrorPageBacklink {
  id: string
  link: {
    en: string
    fr: string
  }
  label: {
    en: string
    fr: string
  }
}

export const errorPageBacklinks: ErrorPageBacklink[] = [
  {
    id: 'default',
    link: {
      en: 'https://www.koodomobile.com',
      fr: 'https://www.koodomobile.com/fr',
    },
    label: {
      en: 'Back to Koodomobile.com',
      fr: 'Retour à Koodomobile.com',
    },
  },
  {
    id: 'selfServe_overview',
    link: {
      en: '/my-account/overview',
      fr: '/my-account/overview',
    },
    label: {
      en: 'Back to Overview',
      fr: "Retourner à l'aperçu",
    },
  },
  {
    id: 'selfServe_myProfile',
    link: {
      en: '/my-account/profile/select',
      fr: '/my-account/profile/select',
    },
    label: {
      en: 'Back to My Profile',
      fr: 'Retour à Mon profil',
    },
  },
  {
    id: 'selfServe_mobileServices',
    link: {
      en: '/my-account/plans/select',
      fr: '/my-account/plans/select',
    },
    label: {
      en: 'Back to Mobile Services',
      fr: 'Retour aux Services mobiles',
    },
  },
]
